export const CotizacionesMapper = aCotizaciones => {
  const mapCotizacion = oServerCotizacion => ({
    monId: oServerCotizacion.monID,
    simbolo: oServerCotizacion.monSim,
    cotizacion: oServerCotizacion.monTC,
    fecha: oServerCotizacion.fecha,
  });

  if (Array.isArray(aCotizaciones)) return aCotizaciones.map(mapCotizacion);
  if ((typeof aCotizaciones).toString() === "object") return mapCotizacion(aCotizaciones);
  return null;
};

export const CotizacionesUnMapper = aCotizaciones => {
  const unMapCotizacion = oCotizacion => ({
    monid: oCotizacion.monId,
    fecha: oCotizacion.fecha,
    montc: oCotizacion.cotizacion,
  });

  if (Array.isArray(aCotizaciones)) return aCotizaciones.map(unMapCotizacion);
  if ((typeof aCotizaciones).toString() === "object") return unMapCotizacion(aCotizaciones);
  return null;
};
